import { Address } from '../users/dto/address';
import { Deserializable } from '../protocols/deserializable';

export class AddressChangeSubmission implements Deserializable {
  public previous!: Address;
  public new!: Address;

  onDeserialize(): void {
    if (!!this.previous) {
      this.previous = window?.injector?.Deserialize?.instanceOf(Address, this.previous);
    }
    if (!!this.new) {
      this.new = window?.injector?.Deserialize?.instanceOf(Address, this.new);
    }
  }
}
